exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-select[data-v-933ea9e8] {\n  background: none !important;\n}\n.glassbox[data-v-933ea9e8] {\n  cursor: pointer;\n}\n.inwardfooter[data-v-933ea9e8] {\n  text-align: right !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-933ea9e8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/components/stockGrn/stockgrn.component.scss
// module id = 2206
// module chunks = 0